<template>
  <v-container fluid class="reimbursement-list mt-3">
    <!-- <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="8" class="d-flex justify-space-between justify-md-start">
              <v-btn color="success" class="button-shadow mr-3" @click="findReimbursementDialog=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row> -->
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-desc
              item-key="_id"
              v-model="selectedOrders"
              loading-text="Loading... Please wait"
              class="reimbursements-table"
              sort-by="reimbursementnum"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="headers"
              :items="reimbursements"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="emailDialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Send Email for {{ 'Reimbursement #' + emailItem.reimbursementnum }} ?
                    </v-card-title>

                    <v-card-text>
                      This action will send email to all employees. After emails are sent, this action cannot be undone. 
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="emailDialog = false">Cancel</v-btn>
                      <v-btn color="success" class="button-shadow" @click="emailReimbursement(emailItem)">Send</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.transactions="{ item }">
                <p v-if="item.transactions.length>0" class="two-line">{{ employees.length>0 ? employees.find(employee=>employee._id==item.transactions[0].employeeid)['employeename'] : '' }} </p>
                <p class="two-line">{{ item.transactions!==undefined ? item.transactions.map(trans=>{return '#' + trans.claimnum}).join(", ") : '' }} </p>
              </template>
              <template v-slot:item.reimbursementnum="{ item }">
                <p class="two-line">{{ item.reimbursementtype  }} {{ item.reimbursementnum  }}</p>
                <p v-if="item.reimbursementdate!=undefined" class="two-line">{{ new Date(item.reimbursementdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.accountid="{ item }">
                {{ accounts.length>0 && accounts.find(account=>account._id == item.accountid)!=null ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
              </template>
              <template v-slot:item.reimbursementtotal="{ item }">
                <p class="two-line">{{ item.transactions.length>0 ? item.transactions.reduce((partial_sum, trans)=>parseFloat(partial_sum) + parseFloat(trans.transamount),0).toFixed(2) : '' }} </p>
              </template>
              <template v-slot:item.reimbursementstatus="{ item }">
                <v-chip
                  v-if="item.reimbursementstatus"
                  :color="item.reimbursementstatus=='Complete' ? 'successConst white--text' : item.reimbursementstatus=='Pending' ? 'warning white--text' : item.reimbursementstatus=='Completed' ? 'greyTint white--text' : 'primaryConst white--text'"
                  small>
                  {{ item.reimbursementstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <!-- <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                </div>
              </template> -->
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ReimbursementList',
  data() {
    return {
      findReimbursementDialog: false,
      emailDialog: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      query: {},
      emailItem: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Reimbursement', value: 'reimbursementnum', sortable: false, width: '10%' },
        { text: 'Claims', value: 'transactions' },
        { text: 'Account', value: 'accountid', width: '15%' },
        { text: 'Amount', value: 'reimbursementtotal', width: '10%' },
        { text: 'Status', value: 'reimbursementstatus', width: '10%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '15%' },
      ],
      reimbursements: [],
      selectedOrders: [],
    }
  },
  computed: {
    ...mapState('MyAccount', ['isReceiving', 'isDeleting']),
    ...mapState('Account', ['accounts']),
    ...mapState('Employee', ['employees']),
  },
  methods: {
    ...mapActions('MyAccount', ["getMyReimbursementsRequest"]),
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    editItem(item) {
      this.$router.push({ name: 'ReimbursementEdit', params: item })
    },
    async emailReimbursement(item) {
      await this.emailReimbursementRequest({_id: item._id});
      this.emailDialog = false;
    },
    printItem(item) {
      this.$router.push({ name: 'ReimbursementPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'ReimbursementView', params: item })
    },
  },
  async created(){
    this.reimbursements = await this.getMyReimbursementsRequest();
    this.reimbursements = this.reimbursements.filter(reimbursement=>reimbursement.transactions!=null && reimbursement.transactions.length>0);
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.employees.length==0) await this.getEmployeesRequest();
  },
  async mounted () {
    
    //this.dataReimbursements.push({reimbursementtotal: this.reimbursements.reduce(function (last, json) {return last + json.reimbursementtotal;}, 0) });

  },
}
</script>

<style src="./List.scss" lang="scss"></style>
